const getters = {
  // app
  appHeaderMenuCurrentItem: state => state.app.headerMenuCurrentItem,
  appHeaderMenuCurrentItemQuery: state => state.app.headerMenuCurrentItemQuery,
  appSideBarOpen: state => state.app.sideBarOpen,
  appSideBarMenuCurrentItem: state => state.app.sideBarMenuCurrentItem,
  appSideBarMenuCurrentItemQuery: state => state.app.sideBarMenuCurrentItemQuery,
  appCurrentRegionKey: state => state.app.currentRegionKey,
  appNewEvents: state => state.app.newEvents,
  appLastEventId: state => state.app.lastEventId,
  appUnhandledAlarmEventCount: state => state.app.unhandledAlarmEventCount,

  // user
  userName: state => state.user.name,
  userPassword: state => state.user.password,
  userRememberPassword: state => state.user.rememberPassword,
  userToken: state => state.user.token,

  // permission

  // liveVideo
  liveVideoLayout: state => state.liveVideo.layout,
  liveVideoActiveStreamNodes: state => state.liveVideo.activeStreamNodes
}

export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js